export default __webpack_public_path__ + "static/repat-home-a5c987646293ade85f883e477dab3d45.png";